import { Block } from "Content/Block";

import bride1 from "res/bride/bride_01.jpg";
import bride2 from "res/bride/bride_02.jpg";
import bride3 from "res/bride/bride_03.jpg";
import bride4 from "res/bride/bride_04.jpg";
import bride5 from "res/bride/bride_05.jpg";
import bride6 from "res/bride/bride_06.jpg";
import bride7 from "res/bride/bride_07.jpg";
import bride8 from "res/bride/bride_08.jpg";
import bride9 from "res/bride/bride_09.jpg";
import bride10 from "res/bride/bride_10.jpg";
import bride11 from "res/bride/bride_11.jpg";
import bride12 from "res/bride/bride_12.jpg";
import bride13 from "res/bride/bride_13.jpg";
import bride14 from "res/bride/bride_14.jpg";
import bride15 from "res/bride/bride_15.jpg";
import bride16 from "res/bride/bride_16.jpg";
import bride17 from "res/bride/bride_17.jpg";
import bride18 from "res/bride/bride_18.jpg";
import bride19 from "res/bride/bride_19.jpg";
import bride20 from "res/bride/bride_20.jpg";
import bride21 from "res/bride/bride_21.jpg";
import bride22 from "res/bride/bride_22.jpg";
import bride23 from "res/bride/bride_23.jpg";
import bride24 from "res/bride/bride_24.jpg";

import origBride1 from "res/bride/orig/bride_01.jpg";
import origBride2 from "res/bride/orig/bride_02.jpg";
import origBride3 from "res/bride/orig/bride_03.jpg";
import origBride4 from "res/bride/orig/bride_04.jpg";
import origBride5 from "res/bride/orig/bride_05.jpg";
import origBride6 from "res/bride/orig/bride_06.jpg";
import origBride7 from "res/bride/orig/bride_07.jpg";
import origBride8 from "res/bride/orig/bride_08.jpg";
import origBride9 from "res/bride/orig/bride_09.jpg";
import origBride10 from "res/bride/orig/bride_10.jpg";
import origBride11 from "res/bride/orig/bride_11.jpg";
import origBride12 from "res/bride/orig/bride_12.jpg";
import origBride13 from "res/bride/orig/bride_13.jpg";
import origBride14 from "res/bride/orig/bride_14.jpg";
import origBride15 from "res/bride/orig/bride_15.jpg";
import origBride16 from "res/bride/orig/bride_16.jpg";
import origBride17 from "res/bride/orig/bride_17.jpg";
import origBride18 from "res/bride/orig/bride_18.jpg";
import origBride19 from "res/bride/orig/bride_19.jpg";
import origBride20 from "res/bride/orig/bride_20.jpg";
import origBride21 from "res/bride/orig/bride_21.jpg";
import origBride22 from "res/bride/orig/bride_22.jpg";
import origBride23 from "res/bride/orig/bride_23.jpg";
import origBride24 from "res/bride/orig/bride_24.jpg";

import shoot1 from "res/shoot/shoot_01.jpg";
import shoot2 from "res/shoot/shoot_02.jpg";
import shoot3 from "res/shoot/shoot_03.jpg";
import shoot4 from "res/shoot/shoot_04.jpg";
import shoot5 from "res/shoot/shoot_05.jpg";
import shoot6 from "res/shoot/shoot_06.jpg";
import shoot7 from "res/shoot/shoot_07.jpg";
import shoot8 from "res/shoot/shoot_08.jpg";
import shoot9 from "res/shoot/shoot_09.jpg";
import shoot10 from "res/shoot/shoot_10.jpg";
import shoot11 from "res/shoot/shoot_11.jpg";
import shoot12 from "res/shoot/shoot_12.jpg";
import shoot13 from "res/shoot/shoot_13.jpg";
import shoot14 from "res/shoot/shoot_14.jpg";
import shoot15 from "res/shoot/shoot_15.jpg";
import shoot16 from "res/shoot/shoot_16.jpg";

import origShoot1 from "res/shoot/orig/shoot_01.jpg";
import origShoot2 from "res/shoot/orig/shoot_02.jpg";
import origShoot3 from "res/shoot/orig/shoot_03.jpg";
import origShoot4 from "res/shoot/orig/shoot_04.jpg";
import origShoot5 from "res/shoot/orig/shoot_05.jpg";
import origShoot6 from "res/shoot/orig/shoot_06.jpg";
import origShoot7 from "res/shoot/orig/shoot_07.jpg";
import origShoot8 from "res/shoot/orig/shoot_08.jpg";
import origShoot9 from "res/shoot/orig/shoot_09.jpg";
import origShoot10 from "res/shoot/orig/shoot_10.jpg";
import origShoot11 from "res/shoot/orig/shoot_11.jpg";
import origShoot12 from "res/shoot/orig/shoot_12.jpg";
import origShoot13 from "res/shoot/orig/shoot_13.jpg";
import origShoot14 from "res/shoot/orig/shoot_14.jpg";
import origShoot15 from "res/shoot/orig/shoot_15.jpg";
import origShoot16 from "res/shoot/orig/shoot_16.jpg";

import { GalleryRenderer } from "./GalleryRenderer";

export const Gallery = ({ setImgSrc }) => {
  const brideImages = [
    {
      thumbnail: bride1,
      original: origBride1,
    },
    {
      thumbnail: bride2,
      original: origBride2,
    },
    {
      thumbnail: bride3,
      original: origBride3,
    },
    {
      thumbnail: bride4,
      original: origBride4,
    },
    {
      thumbnail: bride5,
      original: origBride5,
    },
    {
      thumbnail: bride6,
      original: origBride6,
    },
    {
      thumbnail: bride7,
      original: origBride7,
    },
    {
      thumbnail: bride8,
      original: origBride8,
    },
    {
      thumbnail: bride9,
      original: origBride9,
    },
    {
      thumbnail: bride10,
      original: origBride10,
    },
    {
      thumbnail: bride11,
      original: origBride11,
    },
    {
      thumbnail: bride12,
      original: origBride12,
    },
    {
      thumbnail: bride13,
      original: origBride13,
    },
    {
      thumbnail: bride14,
      original: origBride14,
    },
    {
      thumbnail: bride15,
      original: origBride15,
    },
    {
      thumbnail: bride16,
      original: origBride16,
    },
    {
      thumbnail: bride17,
      original: origBride17,
    },
    {
      thumbnail: bride18,
      original: origBride18,
    },
    {
      thumbnail: bride19,
      original: origBride19,
    },
    {
      thumbnail: bride20,
      original: origBride20,
    },
    {
      thumbnail: bride21,
      original: origBride21,
    },
    {
      thumbnail: bride22,
      original: origBride22,
    },
    {
      thumbnail: bride23,
      original: origBride23,
    },
    {
      thumbnail: bride24,
      original: origBride24,
    },
  ];

  const shootImages = [
    {
      thumbnail: shoot1,
      original: origShoot1,
    },
    {
      thumbnail: shoot2,
      original: origShoot2,
    },
    {
      thumbnail: shoot3,
      original: origShoot3,
    },
    {
      thumbnail: shoot4,
      original: origShoot4,
    },
    {
      thumbnail: shoot5,
      original: origShoot5,
    },
    {
      thumbnail: shoot6,
      original: origShoot6,
    },
    {
      thumbnail: shoot7,
      original: origShoot7,
    },
    {
      thumbnail: shoot8,
      original: origShoot8,
    },
    {
      thumbnail: shoot9,
      original: origShoot9,
    },
    {
      thumbnail: shoot10,
      original: origShoot10,
    },
    {
      thumbnail: shoot11,
      original: origShoot11,
    },
    {
      thumbnail: shoot12,
      original: origShoot12,
    },
    {
      thumbnail: shoot13,
      original: origShoot13,
    },
    {
      thumbnail: shoot14,
      original: origShoot14,
    },
    {
      thumbnail: shoot15,
      original: origShoot15,
    },
    {
      thumbnail: shoot16,
      original: origShoot16,
    },
  ];
  return (
    <div id="gallery">
      <Block caption={"Galerie / Portfolio"}>
        <Block caption={"Brautstylings"} captioninblock>
          <GalleryRenderer
            images={brideImages}
            setImgSrc={setImgSrc}
            name="brides"
          />
        </Block>
        <Block caption={"Shootings"} captioninblock>
          <p>
            Gerne könnt ihr mich auch für verschiedene Shootings buchen. Du hast
            Lust auf eine Zusammenarbeit mit mir? Melde dich gerne, ich freue
            mich!
          </p>
          <GalleryRenderer
            images={shootImages}
            setImgSrc={setImgSrc}
            name="shoots"
          />
        </Block>
      </Block>
    </div>
  );
};
